module.exports = __webpack_public_path__ + "img/selected5-min.26ddb2b6.png";